import { PinIcon } from './PinIcon';

/**
 * author: Google
 * id B1337135-0E57-465F-8C0C-E658C9981A19
 * name pin
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pin.svg
 * tags
 */
export const KeepIcon = PinIcon;
export default KeepIcon